import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography } from "@mui/material"
import PaperDraggable from "../../../../../../components/PaperDraggable"
import SelectTransportadora from "../../../../../../components/SelectsSimpleApiQuery/SelectTransportadora"
import { useState } from "react"
import { useMutation, useQueryClient } from "react-query"
import axiosClient from "../../../../../../lib/axios"
import { enqueueSnackbar } from "notistack"

export default function DialogConcluirPedido({
    open,
    handleClose
}: DialogConcluirPedidoProps) {

    const queryClient = useQueryClient();

    const [transp, setTransp] = useState<{ label: string, id: string, doc: string } | null>(null)

    //queries e mutations
    const { mutate: concluirExpedicao, isLoading } = useMutation({
        mutationKey: "concluir-expedicao",
        mutationFn: (transpId: number) => axiosClient.post("/estoque/concluir-expedicao/" + open, {
            transportador_id: transpId
        }),
        onError: (e) => {
            console.error(e)
            enqueueSnackbar('Erro ao concluir expedição', { variant: 'error' });
        },
        onSuccess: () => {
            enqueueSnackbar('Expedição concluída com sucesso', { variant: 'success' });
            queryClient.invalidateQueries("pesquisar-expedicoes");
            queryClient.invalidateQueries("pesquisar-itens-para-expedir");
            handleClose()
        }
    });
    //

    //valores importantes
    const naoSelectTransp = transp === null
    //

    //funções manipuladoras
    const handleSubmit = () => {
        if (!transp) {
            enqueueSnackbar('Nenhuma transportadora selecionada', { variant: 'error' });
            return
        }
        concluirExpedicao(Number(transp.id))
    }
    //

    return (
        <Dialog
            fullWidth
            open={Boolean(open)}
            onClose={handleClose}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            scroll="body"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                Concluir expedição
            </DialogTitle>

            <DialogContent>
                <Box my={1.5}>
                    <Typography mb={1.5}>Selecione a transportadora responsável</Typography>
                    <SelectTransportadora
                        value={transp}
                        onChange={(newValue) => setTransp(newValue)}
                    />

                    <Divider sx={{ my: 2 }} />

                    <Typography>O pedido será criado no CS9. Deseja continuar?</Typography>
                </Box>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleClose}
                >
                    Cancelar
                </Button>
                <Button
                    autoFocus
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={naoSelectTransp || isLoading}
                >
                    {
                        isLoading &&
                        <CircularProgress size={20} sx={{ mr: 1 }} />
                    }
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogConcluirPedidoProps {
    open: number,
    handleClose: () => void
}

//